import axios from "../axios-auth";

export const letterHeadService = {
  getAllLetterHead,
  getLetterHeadById,
  saveLetterHead,
  getAllLetterHeadTypes,
};

function getLetterHeadById(id) {
  return axios.get("auth/letter-head/" + id);
}

function saveLetterHead(letterHead) {
  if (!letterHead.id) {
    // new brand
    return axios.post("/auth/letter-head", letterHead);
  } else {
    // edit
    return axios.put("/auth/letter-head", letterHead);
  }
}

function getAllLetterHead(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.type) {
    params["type"] = searchParams.type;
  }
  return axios.get("/auth/letter-heads", { params });
}

function getAllLetterHeadTypes() {
  return axios.get("/auth/letter-head-types");
}

